<template>
  <div>
    <!-- Start Bradcaump area -->
    <div class="bradcaump_area bg_image--4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="bradcaump_inner text-center">
              <h2 class="bradcaump-title">关于我们 About Us</h2>
              <nav class="bradcaump-content">
                <b-link class="breadcrumb_item" to="/home">Home</b-link>
                <span id="nipa" class="brd-separetor">/</span>
                <span class="breadcrumb_item active">About Us</span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Bradcaump area -->

    <!-- Start About Area -->
    <div class="about_area bg--white pt--80 pb--110">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-7 col-lg-7 col-12">
            <div class="about_content" v-html="aboutUsContent.content">
            </div>
          </div>
          <div class="col-xl-5 col-lg-5 col-12">
            <div class="thumb">
              <img src="../assets/img/blog/hospital-cleaning.jpg" alt="about img" />
          </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Start Video Block Area -->
    <div class="video_block_area section-pb-xl">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section_title text-center">
              <h2>About Us</h2>
              <p>
                您分享清洁问题，我们定制解决方案
                <br />
                Share your cleaning problems, we will develop solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Video Block Area -->

    <b-container fluid style="padding: 0;">
      <b-row cols="1" cols-sm="2" cols-lg="5" no-gutters>
        <b-col><img src="../assets/img/banner/instagram1.jpg" alt="instagram1 image" /></b-col>
        <b-col><img src="../assets/img/banner/instagram2.jpg" alt="instagram1 image" /></b-col>
        <b-col><img src="../assets/img/banner/instagram3.jpg" alt="instagram1 image" /></b-col>
        <b-col><img src="../assets/img/banner/instagram4.jpg" alt="instagram1 image" /></b-col>
        <b-col><img src="../assets/img/banner/instagram5.jpg" alt="instagram1 image" /></b-col>
      </b-row>
    </b-container>
    <!-- End Instagram Area -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        aboutUsContent: ''
      }
    },
    created() {
      let that = this
      this.$axios
        .get('/api/getaboutus/', {
          params: {
            pk: 1
          }
        })
        .then(function(response) {
          that.aboutUsContent = response.data
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  }
</script>

<style>
  .company_desc {
    padding-top: 20px;
  }
</style>
